// import * as toxi from 'toxiclibsjs';

// 因为遇到了构建问题，所以通过CDN导入并使用全局变量
// 已卸载 npm uninstall toxiclibsjs
const { Vec2D, Rect } = window.toxi.geom;
const { VerletPhysics2D, VerletParticle2D, VerletSpring2D } = window.toxi.physics2d;
const { GravityBehavior, AttractionBehavior } = window.toxi.physics2d.behaviors;

import dumpling_ikin_path from './assets/dumpling_ikin_2.png';
import dumpling_lam_path from './assets/dumpling_lam_2_xMirror.png';

export const createDumplingSketch = (communicator, role, config = {}) => {
  return (p) => {
    // const { Vec2D, Rect } = toxi.geom;
    // const { VerletPhysics2D, VerletParticle2D, VerletSpring2D } = toxi.physics2d;
    // const { GravityBehavior, AttractionBehavior } = toxi.physics2d.behaviors;

    let dpImg_ikin, dpImg_lam;
    let customFont;

    let physics;
    const boundOffset = 10;
    let lockedParticles = []; // 数组来跟踪所有被锁定的粒子
    let selectedParticle;
    const SNAP_DIST = 20 * 20;
    let showPhysics = false;

    let ikinDumpling;

    let lastCommandCheck = 0;
    const commandCheckInterval = 100; // 每100ms检查一次命令
    let pendingCommands = []; // 存储等待执行的命令

    p.preload = () => {
      dpImg_ikin = p.loadImage(dumpling_ikin_path);
      dpImg_lam = p.loadImage(dumpling_lam_path);
      customFont = p.loadFont('/Sabon-BoldItalic.otf');
    };

    p.setup = () => {
      //texture()函数在p5中通常需要 WebGL 渲染器才能正常工作。
      let container = p.canvas.parentElement;
      p.createCanvas(container.clientWidth, container.clientHeight, p.WEBGL); // 创建一个占满容器的WEBGL画布
      p.textFont(customFont);

      // p.pixelDensity(1);
      // p.noSmooth();

      physics = new VerletPhysics2D();
      physics.setDrag(0.05);
      physics.addBehavior(new GravityBehavior(new Vec2D(0, 0.25)));
      physics.setWorldBounds(
        new Rect(
          -p.width / 2 + boundOffset,
          -p.height / 2 + boundOffset,
          p.width - boundOffset * 2,
          p.height - boundOffset * 2
        )
      );

      let initpos = new Vec2D(0, -100);
      let resizeScale = 1;
      let baseNum = 25 * resizeScale;
      let baseLen = 18 * resizeScale;
      let springStr = 0.15;
      let ptlR = 15 * resizeScale;
      // 根据配置中的isFrontFacing创建饺子
      console.log(config.isFrontFacing);

      const initialFrontFace = config.isFrontFacing !== undefined ? config.isFrontFacing : true;
      ikinDumpling = new Blanket(
        initpos,
        baseNum,
        baseLen,
        springStr,
        ptlR,
        dpImg_ikin,
        dpImg_lam,
        initialFrontFace
      );

      // 将方法暴露给对应角色的控制器
      if (role === 'leader') {
        window.dumplingControllers.leader.flip = () => {
          ikinDumpling.enhancedFlip(32);
          // 添加命令到通信器，1秒后follower会执行
          setTimeout(() => {
            communicator.addCommand({ type: 'flip', strength: 32 });
          }, 1000);
        };
        window.dumplingControllers.leader.speak = () => {
          ikinDumpling.speak();
          // 添加命令到通信器，1秒后follower会执行
          setTimeout(() => {
            communicator.addCommand({ type: 'speak' });
          }, 1000);
        };
      } else if (role === 'follower') {
        window.dumplingControllers.follower.flip = () => {
          ikinDumpling.enhancedFlip(32);
        };
        window.dumplingControllers.follower.speak = () => {
          ikinDumpling.speak();
        };
      }
    };

    p.windowResized = () => {
      let container = p.canvas.parentElement;
      p.resizeCanvas(container.clientWidth, container.clientHeight);
      physics.setWorldBounds(
        new Rect(
          -p.width / 2 + boundOffset,
          -p.height / 2 + boundOffset,
          p.width - boundOffset,
          p.height - boundOffset
        )
      );
    };

    p.draw = () => {
      p.background(240);
      physics.update();
      ikinDumpling.display();

      // 如果是follower角色，检查是否有新命令需要执行
      if (role === 'follower') {
        if (p.millis() - lastCommandCheck > commandCheckInterval) {
          checkForCommands();
          lastCommandCheck = p.millis();
        }
        // 执行待处理的命令
        if (pendingCommands.length > 0 && p.frameCount % 5 === 0) {
          const command = pendingCommands.shift();
          executeCommand(command);
        }
      }
    };

    // 检查是否有新命令
    function checkForCommands() {
      const commands = communicator.getCommands();
      pendingCommands.push(...commands);
    }

    // 执行命令
    function executeCommand(command) {
      if (command.type === 'speak') {
        ikinDumpling.speak();
      } else if (command.type === 'flip') {
        ikinDumpling.enhancedFlip(command.strength || 32);
      }
      // 可以添加更多命令类型
    }

    if (role === 'leader') {
      p.mousePressed = () => {
        let mousePos = new Vec2D(p.mouseX - p.width / 2, p.mouseY - p.height / 2);

        for (let i = 0; i < physics.particles.length; i++) {
          let particle = physics.particles[i];
          if (mousePos.distanceToSquared(particle) < SNAP_DIST) {
            selectedParticle = particle.lock();

            selectedParticle.index = i; // 保存索引到粒子对象上
            break;
          }
        }
      };

      p.mouseDragged = () => {
        if (selectedParticle) {
          selectedParticle.set(p.mouseX - p.width / 2, p.mouseY - p.height / 2);
        }
      };

      p.mouseReleased = () => {
        if (selectedParticle) {
          selectedParticle.unlock();
          selectedParticle = null;
        }
      };

      p.keyPressed = () => {
        if (p.key === 'e' || p.key === 'E') {
          showPhysics = !showPhysics;
        } else if (p.key === 'f' || p.key === 'F') {
          ikinDumpling.enhancedFlip(32);
          // 添加命令到通信器，1秒后follower会执行
          setTimeout(() => {
            communicator.addCommand({ type: 'flip', strength: 32 });
          }, 1000);
        } else if (p.key === ' ') {
          ikinDumpling.speak();
          // 添加命令到通信器，1秒后follower会执行
          setTimeout(() => {
            communicator.addCommand({ type: 'speak' });
          }, 1000);
        } else if (p.keyCode === p.LEFT_ARROW) {
        } else if (p.keyCode === p.RIGHT_ARROW) {
        }
      };
    }

    //p.touches 是 p5.js 提供的一个数组，包含当前所有活动的触摸点信息，每个手指的触摸点都会在这个数组中有一个对应的对象
    p.touchStarted = () => {
      p.touches.forEach((touch) => {
        let touchPos = new Vec2D(touch.x - p.width / 2, touch.y - p.height / 2);

        for (let i = 0; i < physics.particles.length; i++) {
          let particle = physics.particles[i];
          if (touchPos.distanceToSquared(particle) < SNAP_DIST) {
            let locked = particle.lock(); // .lock()返回被锁定的粒子对象本身
            locked.index = i;

            //touch.id 是p5.js触摸事件系统为每个触摸点分配的唯一标识符。这个 ID 在整个触摸过程中保持不变，直到手指离开屏幕
            locked.identifier = touch.id; // 存储触摸的唯一标识符
            lockedParticles.push(locked);
            break;
          }
        }
      });
    };

    p.touchMoved = () => {
      p.touches.forEach((touch) => {
        // 查找与此触摸ID关联的粒子
        let particleForTouch = lockedParticles.find((p) => p.identifier === touch.id);
        if (particleForTouch) {
          particleForTouch.set(touch.x - p.width / 2, touch.y - p.height / 2);
        }
      });
    };

    p.touchEnded = () => {
      // 提取所有当前仍在屏幕上的触摸点的 ID
      const currentTouchIds = p.touches.map((t) => t.id);

      // 筛选条件是：粒子的 identifier 属性（之前存储的触摸点 ID）不在 currentTouchIds 数组中
      const particlesToRelease = lockedParticles.filter(
        (p) => !currentTouchIds.includes(p.identifier)
      );
      // 解锁这些粒子
      particlesToRelease.forEach((p) => p.unlock());

      // 筛选条件与步骤 2 相反：只保留那些触摸点 ID 仍在 currentTouchIds 中的粒子
      // 确保lockedParticles 数组，只保留那些仍然被锁定的粒子
      lockedParticles = lockedParticles.filter((p) => currentTouchIds.includes(p.identifier));
    };

    // Blanket 类
    class Blanket {
      constructor(
        center,
        baseNum,
        baseLen,
        springStR,
        ptlR,
        frontImg,
        backImg,
        initialFrontFace = true
      ) {
        this.center = center;

        // 根据initialFrontFace参数决定哪个图片是正面
        if (initialFrontFace) {
          this.frontImg = frontImg;
          this.backImg = backImg;
          this.isIkinFront = true; // ikin在正面
        } else {
          // 交换正反面图片
          this.frontImg = backImg;
          this.backImg = frontImg;
          this.isIkinFront = false; // lam在正面
        }

        this.currentImg = this.frontImg; // 当前显示的图片，初始为正面
        // 变量来跟踪当前显示的是哪个名字
        this.currentDisplayName = this.isIkinFront ? 'ikin' : 'lam';

        let frame0 = frontImg;
        // 动态计算pNumX、pNumY
        let aspectRatio = frame0.width / frame0.height;
        if (aspectRatio >= 1) {
          this.pNumX = baseNum;
          this.pNumY = p.round(this.pNumX / aspectRatio);
        } else {
          this.pNumY = baseNum;
          this.pNumX = p.round(this.pNumY * aspectRatio);
        }

        this.len = baseLen;
        this.springStR = springStR;
        this.particleR = ptlR;

        this.particles = [];
        this.springs = [];
        this.isDone = false;

        // 粒子网格创建
        for (let y = 0; y < this.pNumY; y++) {
          for (let x = 0; x < this.pNumX; x++) {
            let particle = new Particle(
              new Vec2D(
                center.x + x * this.len - (this.pNumX * this.len) / 2,
                center.y + y * this.len - this.pNumY / 2
              ),
              ptlR
            );
            this.particles.push(particle);

            if (x > 0) {
              let previous = this.particles[this.particles.length - 2];
              let c = new Connection(particle, previous, this.len, this.springStR);
              physics.addSpring(c);
              this.springs.push(c);
            }
            if (y > 0) {
              let above = this.particles[this.particles.length - this.pNumX - 1];
              let c = new Connection(particle, above, this.len, this.springStR);
              physics.addSpring(c);
              this.springs.push(c);
            }
          }
        }

        // 添加变量跟踪当前朝向
        this.isFrontFacing = true;
        this.isUpsideDown = false;
      }

      jerk() {
        for (let particle of this.particles) {
          let angle = p.random(p.TWO_PI);
          let strength = p.random(25, 27);
          let force = new Vec2D(p.cos(angle) * strength, p.sin(angle) * strength);
          particle.addForce(force);
        }
      }

      speak() {
        // 根据当前显示的名字决定使用哪个粒子
        let particleIndex;
        let forceY;

        if (this.currentDisplayName === 'ikin') {
          particleIndex = 309;
          forceY = -1000;
        } else {
          // lam
          particleIndex = 313;
          forceY = 600;
        }

        const particle = this.particles[particleIndex];
        const force = new Vec2D(0, forceY);
        particle.addForce(force);
      }

      jerkUpAndDown(strength) {
        let forceUp = new Vec2D(0, -1).normalizeTo(strength);
        let forceDown = new Vec2D(0, 1).normalizeTo(strength);
        for (let y = 0; y < this.pNumY; y++) {
          for (let x = 0; x < this.pNumX; x++) {
            let particle = this.particles[y * this.pNumX + x];
            if (x < this.pNumX / 2) {
              particle.addForce(forceUp);
            } else if (x > this.pNumX / 2) {
              particle.addForce(forceDown);
            }
          }
        }
      }

      detectOrientation() {
        // 取中间的一个四边形
        const midX = Math.floor(this.pNumX / 2);
        const midY = Math.floor(this.pNumY / 2);

        // 获取中间四边形的四个顶点
        const topLeft = this.particles[midY * this.pNumX + midX];
        const topRight = this.particles[midY * this.pNumX + midX + 1];
        const bottomRight = this.particles[(midY + 1) * this.pNumX + midX + 1];
        const bottomLeft = this.particles[(midY + 1) * this.pNumX + midX];

        // 计算两个边向量
        const edge1 = {
          x: topRight.x - topLeft.x,
          y: topRight.y - topLeft.y,
        };

        const edge2 = {
          x: bottomLeft.x - topLeft.x,
          y: bottomLeft.y - topLeft.y,
        };

        // 计算叉积判断正反面
        const crossZ = edge1.x * edge2.y - edge1.y * edge2.x;
        const currentlyFrontFacing = crossZ > 0;

        // 计算上下方向
        // 通过检查"上边"是否在"下边"的下方来判断是否上下颠倒
        // topLeft 和 topRight 应该y坐标小于 bottomLeft 和 bottomRight
        const topY = (topLeft.y + topRight.y) / 2;
        const bottomY = (bottomLeft.y + bottomRight.y) / 2;
        const currentlyUpsideDown = topY > bottomY;

        // 如果方向发生了变化，则更新图片
        if (this.isFrontFacing !== currentlyFrontFacing) {
          this.currentImg = currentlyFrontFacing ? this.frontImg : this.backImg;
          // 更新当前显示的名字
          // 如果isIkinFront为true，则前面显示ikin；如果不是，则前面显示lam
          this.currentDisplayName = currentlyFrontFacing === this.isIkinFront ? 'ikin' : 'lam';
        }

        // 更新状态
        this.isFrontFacing = currentlyFrontFacing;
        this.isUpsideDown = currentlyUpsideDown;

        // console.log(
        //   '当前状态:',
        //   this.isFrontFacing ? '正面' : '背面',
        //   this.isUpsideDown ? '上下颠倒' : '正常方向'
        // );

        return {
          isFrontFacing: this.isFrontFacing,
          isUpsideDown: this.isUpsideDown,
        };
      }

      enhancedFlip(strength = 30) {
        // 先检测当前朝向
        this.detectOrientation();

        const centerX = this.pNumX / 2;

        for (let y = 0; y < this.pNumY; y++) {
          for (let x = 0; x < this.pNumX; x++) {
            let particle = this.particles[y * this.pNumX + x];

            // 计算每个粒子离中心线的距离
            const distanceFromCenter = Math.abs(x - centerX);

            // 基于正反面和上下颠倒的组合状态确定水平力方向
            let horizontalDirection;
            if (!this.isUpsideDown) {
              // 正常方向
              if (this.isFrontFacing) {
                horizontalDirection = x < centerX ? 1 : -1; // 正面正常：左侧向右，右侧向左
              } else {
                horizontalDirection = x < centerX ? -1 : 1; // 背面正常：左侧向左，右侧向右
              }
            } else {
              // 上下颠倒 - 水平力需要反转！
              if (this.isFrontFacing) {
                horizontalDirection = x < centerX ? -1 : 1; // 正面颠倒：使用背面逻辑
              } else {
                horizontalDirection = x < centerX ? 1 : -1; // 背面颠倒：使用正面逻辑
              }
            }

            // 计算水平力大小系数
            const distanceFactor = 1 + (centerX - distanceFromCenter) / centerX;

            // 基于上下颠倒状态确定垂直力
            let verticalFactor, verticalDirection;
            if (!this.isUpsideDown) {
              // 正常方向：上部粒子力大，向上
              verticalFactor = 1 - y / this.pNumY;
              verticalDirection = -1; // 向上的力
            } else {
              // 上下颠倒：下部(看起来是上部)粒子力大，向下
              verticalFactor = y / this.pNumY;
              verticalDirection = 1; // 向下的力
            }

            // 计算最终的力向量
            const force = new Vec2D(
              horizontalDirection * strength * distanceFactor,
              (verticalDirection * verticalFactor * strength) / 2
            );

            particle.addForce(force);
          }
        }

        // 翻转后预期状态会改变
        this.isFrontFacing = !this.isFrontFacing;

        // 切换显示的图片
        this.currentImg = this.isFrontFacing ? this.frontImg : this.backImg;
        // 更新显示名字
        this.currentDisplayName = this.isFrontFacing === this.isIkinFront ? 'ikin' : 'lam';

        console.log(
          '翻转后预期状态:',
          this.isFrontFacing ? '正面' : '背面',
          this.isUpsideDown ? '上下颠倒' : '正常方向'
        );
      }

      display() {
        if (this.isDone) return;

        // // 每次绘制前检测一下方向，确保使用正确的纹理
        // if (p.frameCount % 20 === 0) {
        //   this.detectOrientation();
        // }

        p.noStroke();
        p.beginShape(p.QUADS);
        p.texture(this.currentImg); // 使用当前选择的图片作为纹理

        for (let y = 0; y < this.pNumY - 1; y++) {
          for (let x = 0; x < this.pNumX - 1; x++) {
            let topLeft = this.particles[y * this.pNumX + x];
            let topRight = this.particles[y * this.pNumX + x + 1];
            let bottomRight = this.particles[(y + 1) * this.pNumX + x + 1];
            let bottomLeft = this.particles[(y + 1) * this.pNumX + x];

            p.vertex(
              topLeft.x,
              topLeft.y,
              x * (this.currentImg.width / (this.pNumX - 1)), // U
              y * (this.currentImg.height / (this.pNumY - 1)) // V
            );
            p.vertex(
              topRight.x,
              topRight.y,
              (x + 1) * (this.currentImg.width / (this.pNumX - 1)),
              y * (this.currentImg.height / (this.pNumY - 1))
            );
            p.vertex(
              bottomRight.x,
              bottomRight.y,
              (x + 1) * (this.currentImg.width / (this.pNumX - 1)),
              (y + 1) * (this.currentImg.height / (this.pNumY - 1))
            );
            p.vertex(
              bottomLeft.x,
              bottomLeft.y,
              x * (this.currentImg.width / (this.pNumX - 1)),
              (y + 1) * (this.currentImg.height / (this.pNumY - 1))
            );
          }
        }
        p.endShape();

        if (showPhysics) {
          for (let sp of this.springs) {
            sp.display();
          }
          for (let particle of this.particles) {
            particle.display();
          }
        }

        // 显示点击的particle索引
        if (showPhysics && selectedParticle) {
          p.fill(0, 234, 255);
          p.ellipse(selectedParticle.x, selectedParticle.y, 12, 12);

          // 显示粒子索引
          p.push();
          p.fill(0);

          p.textSize(14);
          p.textAlign(p.CENTER, p.CENTER);

          // 计算索引值
          let index = selectedParticle.index !== undefined ? selectedParticle.index : -1;

          // 计算网格坐标 (x, y)
          let gridX = index % this.pNumX;
          let gridY = Math.floor(index / this.pNumX);

          // 显示索引信息
          p.text(
            `Index: ${index} (${gridX}, ${gridY})`,
            selectedParticle.x,
            selectedParticle.y - 15
          );
          p.pop();
        }

        // 显示名字
        const topLeftParticle = this.particles[12];
        if (topLeftParticle) {
          p.fill(0);
          p.noStroke();
          p.textSize(28);
          p.textAlign(p.CENTER, p.CENTER);

          // 注意：使用WEBGL模式，也不需要调整文本位置
          p.text(this.currentDisplayName, topLeftParticle.x, topLeftParticle.y - 100);
        }
      }

      done() {
        this.isDone = true;
        for (let spring of this.springs) {
          physics.removeSpring(spring);
        }
        this.springs = [];
        for (let particle of this.particles) {
          particle.removeAllBehaviors();
          physics.removeParticle(particle);
        }
        this.particles = [];
        console.log('Done called. Current behaviors count: ' + physics.behaviors.length);
      }
    }

    class Connection extends VerletSpring2D {
      constructor(p1, p2, len, strength) {
        super(p1, p2, len, strength);
      }
      display() {
        p.stroke(0, 0, 255, 100);
        p.line(this.a.x, this.a.y, this.b.x, this.b.y);
      }
    }

    class Particle extends VerletParticle2D {
      constructor(pos, r) {
        super(pos);
        this.r = r;
        this.behaviors = [];
        this.addPtlBehavior(new AttractionBehavior(this, r * 4, -1));
        physics.addParticle(this);
      }
      addPtlBehavior(behavior) {
        this.behaviors.push(behavior);
        physics.addBehavior(behavior);
        return this;
      }
      removeAllBehaviors() {
        for (let behavior of this.behaviors) {
          physics.removeBehavior(behavior);
        }
        this.behaviors = [];
        console.log(
          `Removed all behaviors from particle. Remaining behaviors count: ${physics.behaviors.length}`
        );
        return this;
      }
      display() {
        p.fill(255, 100);
        p.stroke(0);
        p.ellipse(this.x, this.y, this.r * 2, this.r * 2);
      }
    }
  };
};
